import apiClient from "../lib/apiClient";
// =============== admin manage user listings =============== //

// Get specific user listing data to populate fields for updating/patching
export const getUserListingSpecDetailsAdmin = async (id) => {
  try {
    const config = {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      withCredentials: true,
    };
    const { data } = await apiClient.get(
      `/admin/get/user/listing/spec/details/${
        id && id
      }`,
      config
    );
    return data;
  } catch (error) {
    return error && error.response && error.response.data;
  }
};

// Update/patch specific user listing data
export const updateUserListingSpecDetailsAdmin = async (id, listingData) => {
  try {
    const config = {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      withCredentials: true,
    };
    const { data } = await apiClient.patch(
      `/admin/update/user/listing/spec/details/${
        id && id
      }`,
      listingData,
      config
    );
    return data;
  } catch (error) {
    return error && error.response && error.response.data;
  }
};

//
// Find listing by b_id
export const findListingAdmin = async (id) => {
  try {
    const config = {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      withCredentials: true,
    };
    const { data } = await apiClient.post(
      `/admin/find/listing/${id && id}`,
      {},
      config
    );
    return data;
  } catch (error) {
    return error && error.response && error.response.data;
  }
};

export const increaseListingViewCard = async (_id, uid, userId) => {
  try {
    const config = {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      withCredentials: true,
    };
    const { response } = await apiClient.post(
      "/listing/increase-view-card",
      { _id, uid, userId },
      config
    );
    return response;
  } catch (err) {
    return console.log("error");
  }
};

export const increaseListingViewMap = async (_id, uid, userId) => {
  try {
    const config = {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      withCredentials: true,
    };
    const { response } = await apiClient.post(
      "/listing/increase-view-map",
      { _id, uid, userId },
      config
    );
    return response;
  } catch (err) {
    return console.log("error");
  }
};
